import { Component } from "react";

import _ from "underscore";

export default class TableCellAmount extends Component {
  render() {
    let application = this.props.item;

    var acceptedOffer =
      application.LoanOffers && application.LoanOffers.length > 0
        ? _.find(application.LoanOffers, (offer) => {
            return offer.Accepted == true;
          })
        : undefined;

    let appliedAmount = "Not chosen";
    if (application.AppliedAmount)
      appliedAmount = application.AppliedAmount.Amount;

    return (
      <div>
        Applied amount: {appliedAmount}
        {acceptedOffer
          ? ", Amount chosen: " + acceptedOffer.LoanAmount.Amount
          : undefined}
      </div>
    );
  }
}
